<template>
  <ExperiencesSection
    v-if="props.experiencesSections.length > 0"
    :en-stories="props.enStories"
    :experience-sections="props.experiencesSections"
    :on-click-story-view-all="props.onClickStoryViewAll"
    :on-experience-click="props.onExperienceClick"
    :on-view-all="props.onViewAll"
    :spacious="true"
    :theme-list="props.themeList"
  >
    <template #theme-section="{ themeList: slotThemeList }">
      <ThemeSection :on-click-view-all="props.onClickThemeViewAll" :on-theme-click="handleThemeClick" :theme-list="slotThemeList" />
    </template>
    <template #reviews-section>
      <ReviewsSection />
    </template>
    <template #video-section>
      <JourneyThroughJapanSection />
    </template>
  </ExperiencesSection>
  <div class="mb:px-4 bg-beige1 pb-20" data-testid="recommended-experiences-section">
    <div class="md:m-auto md:w-11/12 md:max-w-[1216px]">
      <div class="flex justify-center">
        <AtomsSecondaryButton class="mx-auto" data-testid="experiences-btn" font-mode="en" :is-transparent="true" :on-click="props.onClickExperiencesButton">Find Experiences</AtomsSecondaryButton>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { MinimalEnStoryListViewModel } from '@/models/wabunka/enStories';
import ExperiencesSection from '@/wabunka-src/common/features/Experience/components/RecommendedExperiences/ExperiencesSection/ExperiencesSection.vue';
import type { MinimumFeaturedListViewModel, MinimumFeaturedViewModel } from '@/wabunka-src/common/features/Featured/models/minimunFeatured/minimumFeatured';
import type { ExperienceSectionListViewModel } from '@/wabunka-src/features/Experience';
import JourneyThroughJapanSection from '@/wabunka-src/features/Top/pages/components/JourneyThroughJapanSection/JourneyThroughJapanSection.vue';
import ReviewsSection from '@/wabunka-src/features/Top/pages/components/ReviewsSection/ReviewsSection.vue';
import ThemeSection from '@/wabunka-src/features/Top/pages/components/ThemeSection/ThemeSection.vue';

interface Props {
  onClickExperiencesButton: () => void;
  experiencesSections: ExperienceSectionListViewModel;
  onClickThemeViewAll: () => void;
  onClickStoryViewAll: () => void;
  enStories?: MinimalEnStoryListViewModel;
  themeList?: MinimumFeaturedListViewModel;
  onExperienceClick?: (sectionId: string, experienceSlug: string) => void;
  onViewAll?: (sectionId: string) => void;
  onFeaturedClick?: (type: string, id: string) => void;
}

const props = defineProps<Props>();

const handleThemeClick = (theme: MinimumFeaturedViewModel) => {
  props.onFeaturedClick?.('featured-theme', theme.id);
};
</script>
